<template>
    <div class="antialiased">
      <Sidebar />
      <div class="page">
        <Header></Header>
        <div class="content">
            <div class="container">
                <!-- Page title -->
                <div class="page-header pb-4 border-bottom">
                    <div class="d-flex justify-content-between">
                        <h2 class="page-title">Laporan SLA Sales</h2>
                        <div>
                            <button
                                class="btn btn-white"
                                v-html="ic('filter') + ' Filter'"
                                @click="_filter"
                            >
                            </button>
                        </div>
                    </div>
                </div>
                <div class="alert alert-info" v-if="!isFilter">
                    <i class="fe fe-info mr-2"></i> Pilih filter untuk memuat Laporan SLA Sales
                </div>
                <Nodata v-if="!loading && laporan_sla_sales.length == 0 && isFilter"/>
                <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loading"/>

                <div class="text-center my-6" v-if="!loading && laporan_sla_sales.length > 0">
                    <img :src="asset('doc.png')" alt="" style="width: 200px; opacity: .5">
                    <h3 class="my-3" v-html="`Berhasil Mendapatkan Data: ${laporan_sla_sales.length}`"></h3>
                    <button class="btn btn-primary" :disabled="isDownload" @click="_createExcel()" v-html="isDownload ? spin() : 'Export Excel'"></button>
                </div>

            </div>
        </div>
      </div>

      <!-- Section Modals -->
      <FormFilter
        :isOpen.sync="modals.filter.view"
        @submit="modals.filter.action"
        />
    </div>
</template>
<script>
import helper from "@/assets/js/helper.js";
import FormFilter from "./modals/filter.vue";
import { mapState, mapActions } from 'vuex';

export default {
    name: "LaporanSLASales",
    components: { FormFilter },

    data() {
        return{
            loading: false,
            isFilter: false,
            isDownload: false,
            start_date: '',
            end_date: '',
            modals:{
                filter:{
                    view: false,
                    action: () => {}
                }
            }
        }
    },
    mixins: [helper],
    computed:{
        ...mapState('laporan_sla_sales', {
            laporan_sla_sales: state => state.data,
        }),
    },
    methods: {
        ...mapActions("laporan_sla_sales", ["listLaporanSLASales"]),

        _filter(){
            this.modals.filter.view = true
            this.modals.filter.action = async (params) => {
                this.loading = true
                await this.listLaporanSLASales(params)
                this.start_date = params.start_date
                this.end_date = params.end_date
                this.loading = false
                this.isFilter = true
            }
        },
        async _createExcel(){
            this.isDownload = true;
            let datas = [];
            this.laporan_sla_sales.forEach((laporan, key) => {
                datas.push({
                    id:laporan.id,
                    po_manual:laporan.po_manual,
                    no_invoice:laporan.no_invoice,
                    no_acc:laporan.no_acc,
                    cust_no:laporan.cust_no,
                    nama_toko:laporan.nama_toko,
                    delivered_at:laporan.delivered_at,
                    approved_at:laporan.approved_at,
                    kode_barang:laporan.kode_barang,
                    nama_barang:laporan.nama_barang,
                    nama_brand:laporan.nama_brand,
                    qty_delivered:laporan.qty_delivered,
                    qty_pcs_delivered:laporan.qty_pcs_delivered,
                    in_carton:laporan.in_carton,
                    order_qty:laporan.order_qty,
                    order_pcs:laporan.order_pcs,
                    in_carton_order:laporan.in_carton_order,
                    percentage:laporan.percentage,
                    latetime:laporan.latetime,
                    tagging:laporan.tagging
                })
            })

            this.createExcel({
                data: datas,
                filename: "Laporan SLA Sales pada tanggal " + this.start_date + " - " + this.end_date,
            });
            this.isDownload = false;
        }
    }
}
</script>
